import { AppBar, makeStyles, Tab, Tabs } from '@material-ui/core';
import React, { useContext } from 'react';
import MessagesContext from '../../../contexts/messagesContext';
import { useHistory, useParams } from 'react-router';
import useCheckAccess from '../../../hooks/useCheckAccess';

const styles = makeStyles({
    tabs: {
        borderRadius: '5px',
        backgroundColor: 'rgba(80, 159, 250, 0.16)',
        minHeight: '38px',
        height: '38px',
        boxShadow: 'unset'
    },
    tab: {
        borderRadius: '5px',
        minWidth: '61px',
        width: '61px',
        minHeight: '38px',
        height: '38px',
        fontFamily: 'inherit',
        fontSize: '14px',
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.79',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#232733',
        '&:disabled': {
            cursor: 'not-allowed !important',
            pointerEvents: 'auto !important'
        }
    },
    active: {
        backgroundColor: '#509ffa',
        color: '#fff'
    }
});

const DayAndWeekSwitch = () => {
    const classes = styles();
    const params = useParams();
    const { messages } = useContext(MessagesContext);
    const history = useHistory();
    const { notEditDemographic } = useCheckAccess();
    const filterData = [
        { label: messages.day, value: 'day' },
        { label: messages.week, value: 'week' }
    ];
    const handleChange = (e, tabValue) => {
        history.push(`/${params.clinicId}/appointment/${tabValue}`);
    };

    return (
        <>
            {' '}
            <div>
                <AppBar position="static" key="appbar" className={classes.tabs}>
                    <Tabs
                        className={classes.tabs}
                        value={params?.type}
                        onChange={handleChange}
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: 'transparent'
                            }
                        }}
                    >
                        {filterData.map((item, index) => (
                            <Tab
                                disabled={notEditDemographic}
                                key={index}
                                value={item.value}
                                label={item.label}
                                classes={{
                                    root: classes.tab,
                                    selected: classes.active
                                }}
                            />
                        ))}
                    </Tabs>
                </AppBar>
            </div>
        </>
    );
};

export default DayAndWeekSwitch;
